module.exports = __webpack_public_path__ + "static/media/p_6_0.aa4de026.png";